export default {
  metadata: {
    version: '1.0.0',
    id: 'notification-button-1.0.0',
    name: 'JDSNotificationButton'
  },
  hierarchy: {
    container: ['jds-text', 'icon']
  },
  base: {
    container: {
      'padding-top': '{n_0}',
      'padding-right': '{n_1}',
      'padding-bottom': '{n_2}',
      'padding-left': '{n_3}',
      'background-color': '{n_4}',
      'border-radius': 1000,
      'border-width': '1',
      'border-color': '{n_5}',
      behavior: {
        hover: {
          'border-color': '{n_6}'
        },
        active: {
          'background-color': '{n_7}'
        },
        focus: {
          'border-width': '4',
          'border-color': '{n_8}'
        }
      }
    },
    icon: {
      size: '{n_14}',
      color: '{n_13}'
    },
    'jds-text': {
      'font-family': '{text_187}',
      color: '{text_17}',
      'font-size': '{text_186}',
      'line-height': '{text_188}',
      'letter-spacing': '{text_189}',
      'font-weight': '{text_190}',
      'text-decoration': '{text_7}',
      'text-transform': '{text_base_text_text-transform}'
    }
  },
  variant: {
    isDisabled: {
      true: {
        container: {
          disabled: true,
          opacity: '{n_9}'
        }
      }
    },
    kind: {
      tertiary: {
        container: {
          'border-width': '0',
          behavior: {
            hover: {
              'background-color': '{n_10}'
            },
            active: {
              'background-color': '{n_11}'
            },
            focus: {
              'background-color': '{n_12}'
            }
          }
        }
      }
    },
    _hasLabel: {
      false: {
        container: {
          'padding-top': '{n_15}',
          'padding-bottom': '{n_16}',
          'padding-left': '{n_17}',
          'padding-right': '{n_18}'
        },
        'jds-text': {
          hidden: true
        }
      }
    },
    _hasIcon: {
      true: {
        icon: {
          hidden: false
        }
      }
    }
  },
  api: {
    config: {
      isDisabled: {
        values: [false, true]
      },
      kind: {
        values: ['secondary', 'tertiary']
      },
      _hasLabel: {
        values: [true, false]
      },
      _hasIcon: {
        values: [false, true]
      }
    },
    data: {
      icon: {
        value: {
          type: 'icon',
          name: 'icon'
        }
      },
      'jds-text': {
        value: {
          type: 'string',
          name: 'label'
        }
      }
    },
    events: {
      container: {
        onClick: 'onClick'
      }
    },
    a11y: {
      container: {
        properties: {
          role: {
            value: 'button'
          },
          'aria-label': {
            name: 'ariaLabel',
            prop: 'label'
          },
          'aria-describedby': {
            name: 'ariaDescribedby',
            platform: 'web,ios'
          }
        }
      }
    }
  }
};
